import request from '@/utils/request'

let CityApi = {

  /*城市设置列表*/
  list(data) {
    return request._post('/shop/plus.city.Index/index', data);
},
/*添加城市设置*/
add(data) {
    return request._post('/shop/plus.city.Index/add', data);
},
/*修改城市设置*/
edit(data) {
    return request._post('/shop/plus.city.Index/edit', data);
},
/*删除城市设置*/
del(data) {
    return request._post('/shop/plus.city.Index/del', data);
},
/*城市设置详情*/
detail(data) {
  return request._post('/shop/plus.city.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.city.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.city.Setting/getSetting', data, errorback);
    },
      // 设置代理
      setting(data) {
        return request._post('/shop/plus.city.regiontree/setting', data);
    },
    // 获取设置
    getSettings(data){
        return request._post('/shop/plus.city.regiontree/getSettings', data);
    },
    /*获取区域树*/
    getTree(data, errorback) {
        return request._post('/shop/plus.city.Index/getTree', data);
      },
          /*获取区域树*/
    getTreeStatus(data, errorback) {
        return request._post('/shop/plus.city.Index/getTreeStatus', data);
      },
    /*开启代理*/
    open(data) {
        return request._post('/shop/plus.city.Index/open', data);
    },
}
export default CityApi;



// WEBPACK FOOTER //
// ./src/api/city.js